<div class="container">
  <div class="row eds-header">
  <div class="column-12">
    <app-esri-map></app-esri-map>
  </div>
    <div class="column-12">
      <app-table></app-table>
    </div>
</div>
</div>
